export default __webpack_public_path__ + "static/artifakt-legend-light-4335c54b61410c146f8a15ff35ed85ce.woff";